/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S13_P1_AInputs */

const tr_mesafeli_s13_p1_a = /** @type {(inputs: Mesafeli_S13_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri, Aboneliği herhangi bir zamanda, önceden haber verme süresine tabi olmaksızın, Platform içi veya yazılı bildirimle bedelsiz olarak iptal edebilir veya feshedebilir; tüketici sıfatını haiz Müşteriler bakımından bu hak, yıllık planda Abonelik Sözleşmeleri Yönetmeliği Madde 22/1'den doğar. Fesih usulü ve iade koşulları`)
};

const en_mesafeli_s13_p1_a = /** @type {(inputs: Mesafeli_S13_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Customer may cancel or terminate the Subscription free of charge at any time without any advance notice period, either in the Platform or in writing; for Customers who qualify as consumers this right arises, for the annual plan, from Abonelik Sözleşmeleri Yönetmeliği Madde 22/1. The termination procedure and the refund conditions are set out in detail on the`)
};

const de_mesafeli_s13_p1_a = /** @type {(inputs: Mesafeli_S13_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kunde kann das Abonnement jederzeit ohne Vorankündigungsfrist durch Mitteilung in der Plattform oder in Schriftform kostenfrei kündigen oder beenden; für Kunden mit Verbrauchereigenschaft ergibt sich dieses Recht beim Jahresplan aus Abonelik Sözleşmeleri Yönetmeliği Madde 22/1. Das Kündigungsverfahren und die Erstattungsbedingungen sind ausführlich auf der Seite`)
};

const ru_mesafeli_s13_p1_a = /** @type {(inputs: Mesafeli_S13_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Клиент вправе в любое время без срока предварительного уведомления бесплатно отменить или расторгнуть Подписку через Платформу или письменно; для Клиентов, имеющих статус потребителя, это право при годовом плане вытекает из Abonelik Sözleşmeleri Yönetmeliği Madde 22/1. Порядок расторжения и условия возврата подробно изложены на странице`)
};

/**
* | output |
* | --- |
* | "The Customer may cancel or terminate the Subscription free of charge at any time without any advance notice period, either in the Platform or in writing; for..." |
*
* @param {Mesafeli_S13_P1_AInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s13_p1_a = /** @type {((inputs?: Mesafeli_S13_P1_AInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S13_P1_AInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s13_p1_a(inputs)
	if (locale === "de") return de_mesafeli_s13_p1_a(inputs)
	if (locale === "ru") return ru_mesafeli_s13_p1_a(inputs)
	return tr_mesafeli_s13_p1_a(inputs)
});